import Card from '@zenbusiness/zui/Card';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const VeloChatWrapper = superstyled({
  name: 'VeloChat',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    // Create a border with the gradient
    border: '2px solid transparent',
    // linting-disable-next-line max-lenth
    background: `linear-gradient(${theme.palette.background.default}, ${theme.palette.background.default}) padding-box, linear-gradient(249.5deg, #3971E7 27.22%, #33F28B 100%) border-box`,
  }),
});
